module.exports = __webpack_public_path__ + "static/media/searchImg.bb7d4d23.jpg";